import { formatCurrency } from "@/utils/utils"
import styles from "@/styles/view-cart.module.scss"

interface OrderSummaryProps {
  discountInfo: any
  paymentInfo: any
}

const OrderSummary = ({ discountInfo, paymentInfo }: OrderSummaryProps) => (
  <div className={styles['price-box']}>
    <div className={styles['price-line']}>
      <div className={styles['priceLabel']}>Sub Total:</div>
      <div className={styles['priceValue']}>{formatCurrency(paymentInfo.subTotal || 0)}</div>
    </div>
    <div className={styles['price-line']}>
      <div className={styles['priceLabel']}>Shipping:</div>
      <div className={styles['priceValue']}>{paymentInfo.shippingError > 0 ? 'N/A' : formatCurrency(paymentInfo.shipping || 0)}</div>
    </div>
    {
      discountInfo.couponDiscountValue > 0
      &&
      <div className={styles['price-line']}>
        <div className={styles['priceLabel']}>Coupon:</div>
        <div className={styles['priceValue']}>-{formatCurrency(discountInfo.couponDiscountValue || 0)}</div>
      </div>
    }
    {
      discountInfo.credits > 0
      &&
      <div className={styles['price-line']}>
        <div className={styles['priceLabel']}>Credits:</div>
        <div className={styles['priceValue']}>-{formatCurrency(discountInfo.credits || 0)}</div>
      </div>
    }
    {
      discountInfo.pointsValue > 0
      &&
      <div className={styles['price-line']}>
        <div className={styles['priceLabel']}>CrazyPoints:</div>
        <div className={styles['priceValue']}>-{formatCurrency(discountInfo.pointsValue || 0)}</div>
      </div>
    }

    <div className={styles['price-line']}>
      <div className={`${styles['priceLabel']} ${styles['bold']}`}>Total Amount:</div>
      <div className={`${styles['priceValue']} ${styles['bold']}`}>{formatCurrency(paymentInfo.total || 0)}</div>
    </div>
  </div>
)

export default OrderSummary
